import React, { useState, useEffect } from 'react'
import h_images from '../../Images/new.gif'
import {Link} from 'react-router-dom'
function RegistrationMarquee() {
  const [makeydata, setMarkeyData] = useState([
    {
        markeyName: 'For Better user friendly experience use Laptop /Desktop or PC while filling out the application .',
        markeyUrl: '#'
    }
  ])
  return (
    <div>
      <section className="Regmarqueesection">

        <marquee behavior="" direction="" className="marqueestyle flex"
        >

          <div className='flex gap-6'>
            {
              makeydata.length >= 1 ? <>
                {
                  makeydata.map((e, i) => {
                    
                    return (
                      
                        <button key={i+1} className="marqueetext" style={{ display: 'flex' }}>
                          <a href={e.markeyUrl} target='_blank' style={{ textTransform: 'none', color: 'black' }}>
                            {e.markeyName}
                          </a>
                          <img src={h_images} />
                        </button>
                      
                    )
                  })
                }
              </> : null
            }
          </div>


        </marquee>


      </section>
    </div>
  )
}

export default RegistrationMarquee